{
  "services-mobile-top-ups-dynamic": {
    "meta": {
      "title": "Envía recargas móviles a {country} - MAJORITY",
      "description": "¡Envía recargas móviles gratis a {country}! Entrega instantánea y segura."
    },
    "hero": {
      "title": "Envía recargas móviles a {country}",
      "body": "Estamos trabajando duro para ofrecerte recargas sin comisiones a {country}. Vuelve pronto.",
      "cta": "Ver más países"
    },
    "generic": {
      "meta": {
        "title": "Envía recargas móviles a {country}",
        "description": "Estamos trabajando duro para ofrecerte recargas sin comisiones a {country}. Vuelve pronto."
      },
      "hero": {
        "title": "Envía recargas móviles a {country}",
        "body": "Comparte créditos con tus seres queridos en tu país, ¡sin cargos!",
        "cta": "Comenzar",
        "cta_1": "Ver más países"
      },
      "no_fee_content_box": {
        "tagline": "Recargas móviles",
        "title": "Recarga para {country} gratis",
        "body": "¡Mantente en contacto con tus amigos y familiares en {country}! Envía recargas a cualquier celular en {country} sin pagar cargos extra. Además, con nuestra entrega instantánea y segura, siempre podrás mantenerte conectado.",
        "cta": "Comenzar",
        "canvas": "Ahorra y envía más"
      },
      "whats_recarga_content_box": {
        "tagline": "Recargas móviles",
        "title": "¿Qué son las recargas?",
        "body": "Las recargas te permiten enviar créditos móviles a tu familia y amigos en {country}. Los créditos se envían a través de Cubacel en USD y se reciben en CUP, los cuales pueden utilizarse para hacer llamadas, enviar mensajes de texto y más.",
        "cta": "Comenzar"
      },
      "how_to_content_box": {
        "tagline": "Recargas móviles",
        "title": "Cómo enviar recargas a {country}",
        "body": "La mejor manera de enviar recargas a {country} es con la app MAJORITY. Simplemente abre la app y sigue las siguientes instrucciones para comenzar:\n+ Pulsa \"Enviar\" en la parte inferior de la pantalla\n+ Pulsa \"Recarga móvil\"\n+ Elige la persona a la que deseas enviar la recarga en {country}\n+ Ingresa la cantidad que deseas enviar en USD\n+ ¡Envía!",
      
        "cta": "Comenzar"
      },
      "faq": {
        "title": "Preguntas frecuentes",
        "faqs": [
          {
            "question": "¿Puedo usar MAJORITY si no soy un migrante?",
            "answer": "¡Sí! Todos son bienvenidos. Si alguna de las funciones de nuestra app te interesa, regístrate y pruébala."
          },
          {
            "question": "¿Es MAJORITY un banco?",
            "answer": "Somos una app de membresía financiera y Axiom Bank, N.A., miembro de la FDIC, brinda nuestros servicios financieros. Axiom Bank, N.A., también emite nuestra Tarjeta de débito MAJORITY Visa® conforme a una licencia de Visa U.S.A. Inc. ¡La tarjeta se puede utilizar en cualquier lugar donde se acepte Visa!"
          },
          {
            "question": "¿Qué es MAJORITY?",
            "answer": "MAJORITY es la primera membresía financiera desarrollada por migrantes, para migrantes. Después de registrarte, ¡recibes una cuenta asegurada por la FDIC sin cargos por sobregiro, una Tarjeta de Débito Visa®, envíos de dinero sin cargos, llamadas internacionales gratuitas y baratas, y más!"
          },
          {
            "question": "¿Dónde está MAJORITY?",
            "answer": "Tenemos oficinas en Houston, Miami y Estocolmo, Suecia. Visítanos en nuestro lugar de encuentro MAJORITY Meetup Houston, ubicado en 9801 V Bissonnet Street, Houston, Texas 77036, Estados Unidos."
          },
          {
            "question": "¿Estará seguro mi dinero con MAJORITY?",
            "answer": "Absolutamente. Tu cuenta MAJORITY está asegurada por la FDIC, así que no importa si estás en EE.UU. o en el extranjero, el dinero en tu cuenta está asegurado por la FDIC hasta por $250,000. Además, podrás acceder a la app desde cualquier parte del mundo, así que ¡no tienes de qué preocuparte."
          }
        ]
      }
    }
  }
  
}